/**
 * @generated SignedSource<<6f458892faa1c068c52c264a478213db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateTestObjectMutation$variables = {
  name: string;
};
export type CreateTestObjectMutation$data = {
  readonly createTestObject: {
    readonly id: string;
    readonly name: string;
  };
};
export type CreateTestObjectMutation = {
  response: CreateTestObjectMutation$data;
  variables: CreateTestObjectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "TestObject",
    "kind": "LinkedField",
    "name": "createTestObject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateTestObjectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateTestObjectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1492b4c6828894100bcb6253c43204c3",
    "id": null,
    "metadata": {},
    "name": "CreateTestObjectMutation",
    "operationKind": "mutation",
    "text": "mutation CreateTestObjectMutation(\n  $name: String!\n) {\n  createTestObject(input: {name: $name}) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "56a27627541beb8e37a18348d3eadae9";

export default node;
